import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=0670d6ca&scoped=true"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=0670d6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670d6ca",
  null
  
)

export default component.exports